export default __webpack_public_path__ + "static/media/rabbit4.a5f815fb.gif";